@import "../follow-up-actions/follow-up-actions.scss";

.conversational-search-message-follow-up-mediator {
  animation: fade 1s forwards;
  opacity: 0;

  &__actions {
    animation: fade-out 0.2s forwards;
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    display: none;
  }
}
